<div class="container">
  <ng-container *ngIf="isNaturalPerson; else company">
    <i aria-hidden="true" class="icon-person-outline"></i>
  </ng-container>
  <ng-template #company>
    <i aria-hidden="true" class="icon-work-outline"></i>
  </ng-template>
  <div class="personal-info-cont" (click)="selectOption()">
    <span class="name">{{name}}</span>
    <span class="dni"><span class="type-dni">{{documentBillingAbreviation$ | async}}: </span>{{documentNumber}}</span>
  </div>
  <div class="options" (click)="toggleOptions()">
    <span class="separator">●</span>
    <span class="separator">●</span>
    <span class="separator">●</span>
  </div>
</div>

<div *ngIf="showOptions" (click)="toggleOptions()" class="overlay-container"></div>

<div *ngIf="showOptions" class="transparent-container" (click)="toggleOptions()">
  <section class="opt-cont" [class.is-last]="isLast" [class.only-one]="onlyOne">
    <div class="options-container">
      <span (click)="edit.emit(billing)" class="edit">
        <i aria-hidden="true" class="icon-edit"></i>
        <span>{{'BUTTONS.EDIT' | transloco}}</span>
      </span>
      <span (click)="remove.emit()">
        <i aria-hidden="true" class="icon-cancel"></i>
        <span>{{ 'BOOKING_MODULE.BILLING.DELETE' | transloco }}</span>
      </span>
    </div>
  </section>
</div>
